import { colors } from '@/styles/colors'

export const nodeColors = [
  colors.blue[300],    // #4299E1
  colors.green[300],   // #48BB78
  colors.orange[300],  // #ED8936
  colors.purple[300],  // #9F7AEA
  colors.red[300],     // #F56565
  colors.teal[300],    // #38B2AC
  colors.pink[300],    // #ED64A6
  colors.yellow[300],  // #ECC94B
]